import type { FC } from 'react';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { ModalDesktop as Modal } from '@alfa-bank/site-modal/desktop';
import { AnalyticsEventSender } from '@alfa-bank/site-analytics-event-sender/analytics-event-sender';

import { selectAppMeta } from '../../../store';
import type { TDeliverySystemErrorStepDesktop } from '../model';
import { replaceLabelToPhone } from '../../../helpers/helpers';
import { defaultDeliverySystemErrorStepSettingsDesktop } from '../config/default-values';
import { analyticsDeliverySystemErrorSmev } from '../analytics';

export const DeliverySystemErrorStepDesktop: FC<TDeliverySystemErrorStepDesktop> = ({
    Aligner,
    Text,
    Img,
    Link,
    Button,
    image,
    button = defaultDeliverySystemErrorStepSettingsDesktop.button,
    title = defaultDeliverySystemErrorStepSettingsDesktop.title,
    subtitle = defaultDeliverySystemErrorStepSettingsDesktop.subtitle,
    modalTitle = defaultDeliverySystemErrorStepSettingsDesktop.modalTitle,
    modalSubtitle = defaultDeliverySystemErrorStepSettingsDesktop.modalSubtitle,
    modalButtonText = defaultDeliverySystemErrorStepSettingsDesktop.modalButtonText,
}) => {
    const [isOpenModal, toggleModal] = useState(true);
    const { phone } = useSelector(selectAppMeta);
    const subtitleWithPhone = replaceLabelToPhone(subtitle, phone);

    const handleToggleModal = () => {
        toggleModal(prevState => !prevState);
    };

    return (
        <>
            <Aligner>
                {image && (
                    <Img
                        height={image.height}
                        src={image.src}
                        styler={{ marginBottom: 32 }}
                        width={image.width}
                    />
                )}
                <Text styler={{ marginBottom: 16, marginTop: 0 }} tag="h2" view="medium">
                    {title}
                </Text>
                <Text styler={{ marginTop: 0, marginBottom: 0 }} view="primary-medium">
                    {subtitleWithPhone}
                </Text>
                {button && (
                    <Aligner styler={{ marginTop: 24, marginBottom: 0 }}>
                        <AnalyticsEventSender
                            $events={{
                                onClick: {
                                    data: analyticsDeliverySystemErrorSmev.buttonClick,
                                },
                            }}
                        >
                            <Link border="hidden" href={button.href} target="_blank">
                                <Button size="s" view="primary">
                                    {button.text}
                                </Button>
                            </Link>
                        </AnalyticsEventSender>
                    </Aligner>
                )}
            </Aligner>
            {isOpenModal && (
                <Modal onClose={handleToggleModal} size="l">
                    <Aligner>
                        <Text styler={{ marginTop: 0, marginBottom: 32 }} tag="h3" view="medium">
                            {modalTitle}
                        </Text>
                        <Text
                            styler={{ marginTop: 0, marginBottom: 32 }}
                            tag="p"
                            view="primary-medium"
                        >
                            {modalSubtitle}
                        </Text>
                        <Button onClick={handleToggleModal} size="s" view="primary">
                            {modalButtonText}
                        </Button>
                    </Aligner>
                </Modal>
            )}
        </>
    );
};
